/**
 * @file 上报事件名
 * @author alfielv
 */

// 上报事件名称
export default {
  // 「保存至看板」
  AI_AGENT_SAVE_BOARD: 'ai-agent-save-board',
  // 「分享看板」
  AI_AGENT_SHARE_BOARD: 'ai-agent-share-board',
};

// 存储“已反馈”操作
export const HAS_FEEDBACK = 'ai-agent-has-feedback';

// 发送user prompt
export const SEND_USER_PROMPT = 'ai-agent-send-user-prompt';

// 点击看板生成提示词
export const CLICK_BOARD_GENERATE_PROMPT = 'ai-agent-click-board-generate-prompt';
// 点击查数据提示词
export const CLICK_DATA_QUERY_PROMPT = 'ai-agent-click-data-query-prompt';
